import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON_ERROR } from 'src/app/shared/named-icons.config';

export enum Type {
  INFO = 'INFO',
  ERROR = 'ERROR'
}

@Component({
  selector: 'app-inline-message',
  templateUrl: './inline-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineMessageComponent {
  @Input()
  public message: string;
  @Input()
  public showIcon: boolean = false;
  @Input()
  public type: Type = Type.ERROR;
  @Input()
  public header: boolean = false;

  public readonly ICONS = {
    ICON_ERROR,
  };

  protected readonly Type = Type;
}
